export class AdminApproveProfilePhotosController {
  constructor($scope, UserService, PhotoService, $http, $modal, toastr, $rootScope, $timeout) {
    $scope.vm = this;
    this.http = $http;
    this.UserService = UserService;
    this.PhotoService = PhotoService;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.modal = $modal;
    this.toastr = toastr;
    this.timeout = $timeout;
    this.scope.users = {};
    this.$broadcast = $scope.$broadcast;

    this.scope.pagination = {
      total: 0,
      currentPage: 1,
      limit: 12
    };

    this.scope.allUsersSelected = {
      state: false
    };

    this.scope.showModal = {
      feedback: false,
      image: false
    };

    this.scope.usersSelected = {};
    this.scope.permanentUsers = {};

    this.scope.feedback = {
      toId: '',
      fromId: '',
      reason: '',
      extraMessage: ''
    };

    this.scope.imageEdit = {
      url: '',
      userId: null,
      image: {},
      params: {}
    };

    this.scope.feedbackMessages = [
      //"id" : 1,
      {
        "text": "Personal",
        "value": "Estimado Usuario:\n\n\n\n\n\nAtentamente\n" + "Datingchile.cl" + "\n"
      }, {
        //"id" : 2,
        "text": "Foto sin compañía",
        "value": "Es necesario que subas tu foto nuevamente ya que debes salir solo en las fotografías, sin compañía de nadie porque es muy fácil confundir a los usuarios.\n Te pedimos que cargues nuevamente una foto en donde sólo salga tu rostro.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 3,
        "text": "Fotografía muy profesional",
        "value": "Lamentablemente tenemos un problema con tu fotografía debido a que se ve muy profesional.\n Te recordamos que por favor no subas:\n * Fotos de estudio\n* Modelos\n*Actores o actrices\n\nAdemás te reiteramos que sólo puedes colocar una foto de tu rostro y en la que pueda distinguirse claramente.\nSi es que nos estamos equivocando, te pedimos por favor subir otra fotografía para verificar la autenticidad de esta.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 5,
        "text": "Foto original, sin filtros y graficas",
        "value": "Lamentablemente tenemos un pequeño problema con tu fotografía. Te pedimos si puedes cambiarla y por favor subir una foto original, sin gráficas, sobrepuesta, sin marcos y sin filtros.\nMuchas gracias y disculpa las molestias.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 6,
        "text": "Cara Claramente visible",
        "value": "Lamento interrumpirte, pero necesitamos que por favor cargues nuevamente tu foto de perfil ya que no es posible apreciar claramente tu rostro. Debe ser una imagen en donde tu cara pueda distinguirse.\n\n    * Debes estar mirando de frente\n    * La fotografía debe ser de una calidad adecuada en donde tu rostro no salga borroso, por lo tanto trata de no subir una foto muy pequeña o sacada con un celular.\n    No debes estar muy lejos, porque te ves muy pequeño y no se puede ver bien tu cara.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 7,
        "text": "Foto no cumple con las condiciones",
        "value": "Lamentablemente tu foto no cumple con las condiciones de la página. Tenemos una norma de que solo puedes mostrar desde el pecho para arriba, a menos que estás en una situación normal, como en la playa por ejemplo. Además no se aceptará ninguna foto que tenga posiciones demasiado eróticas o imágenes vulgares.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 12,
        "text": "Fotografía en mala posición",
        "value": "Recuerda que al subir tu fotografía, debes darte cuenta que esté en la posición correcta, de rostro derecho y frontal para que los usuarios puedan visualizar correctamente tu cara.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }, {
        //"id" : 14,
        "text": "Fotografía sin Morisquetas",
        "value": "Te pedimos que por favor cargues otra foto nuevamente, porque no es posible subir imágenes en donde salgas haciendo morisquetas (sacar a lengua, cerrar los ojos, hacer algún gesto con las manos, etc.) debido a que tu rostro no puede apreciarse claramente y eso es importante para que los demás usuarios puedan verte.\n\nAtentamente\n" + "Datingchile.cl" + "\n\n\n"
      }
    ];

    this.triggerCountdown = 0;

    this.init();
  }

  init() {
    this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);

      this.limitTimout = this.timeout(() => {
        this.scope.getFilterUsers(1);
      }, 200);
    }

    this.scope.getAvatar = (url, size) => {
      return `/dating-profile-photos/${url}${size}.jpg`
    }

    this.scope.getFilterUsers = (page) => {
      this.scope.pagination.currentPage = page;
      var limit = this.scope.pagination.limit;
      var request = {
        "photoprofile.approved": false
      };
      var filtr = JSON.stringify(request);

      // Returned so callers can act once the rows are back, e.g. to restore the
      // scroll position after an edit.
      return this.UserService.getFilteredUsers(filtr, page, limit)
        .then((_res) => { let response = _res.data;
          if (response.success) {
            this.scope.users = response.data;
            this.scope.pagination.total = response.itemCount;

            // Remove old users' keys when being navigated to new page
            this.scope.usersSelected = {};


            _.forEach(this.scope.users, (user) => {
              this.scope.usersSelected[user._id] = false;
            });

            this.scope.allUsersSelected.state = false;
          }
        })
        .catch((response) => { let error = response.data;
          console.log('Cannot get new users:   ', error);
        });
    };

    /**
     * Check every checkbox on the page
     */
    this.scope.selectAllUsers = () => {
      var check = this.scope.allUsersSelected.state;

      _.forEach(this.scope.usersSelected, (user, key) => {
        this.scope.usersSelected[key] = !!check;
      })
    };

    /**
     * Send approved data to server
     */
    this.scope.sendApproveData = () => {
      if(!confirm('Do you really want to approve avatar?')) {
        return;
      }

      _.forEach(this.scope.usersSelected, (user, key) => {
        if (this.scope.usersSelected[key] === true) {
          // send
          this.triggerCountdown++;
          this.PhotoService.approveAvatar({
              id: key,
              checked: this.scope.usersSelected[key]
            })
            .then((response) => {
              // Call refresh when all queries will be completed
              this.triggerCountdown--;
              if (this.triggerCountdown === 0)
                this.refreshPage();
            })
            .catch((response) => {
              this.triggerCountdown--;
              if (this.triggerCountdown === 0)
                this.refreshPage();
            });

        }
      });
    };

    this.scope.sendRejectData = () => {
      if(!confirm('Do you really want to reject avatar?')) {
        return;
      }

      _.forEach(this.scope.usersSelected, (user, key) => {
        if (this.scope.usersSelected[key] === true) {
          // send
          this.triggerCountdown++;

          this.PhotoService.rejectAvatar({
              id: key,
              checked: this.scope.usersSelected[key],
              reason: this.scope.feedback.reason.text,
              motivation: this.scope.feedback.extraMessage
            })
            .then((response) => { let data = response.data;
              // Call refresh when all queries will be completed
              this.triggerCountdown--;
              if (this.triggerCountdown === 0) {

                // Reset fields
                this.scope.feedback.reason = '';
                this.scope.feedback.extraMessage = '';
                $('body').css('overflow', 'auto');
                $('#modal').modal('hide');
                $('.modal-edit-image').css('visibility', 'hidden');
                this.refreshPage();
              }
            })
            .catch((response) => { let err = response.data;
              console.log(err);
              this.triggerCountdown--;
              if (this.triggerCountdown === 0) {

                // Reset fields
                this.scope.feedback.reason = '';
                this.scope.feedback.extraMessage = '';
                $('body').css('overflow', 'auto');
                $('#modal').modal('hide');
                $('.modal-edit-image').css('visibility', 'hidden');
                this.refreshPage();
              }
            });
        }
      });
    };

    this.scope.getFilterUsers(this.scope.pagination.currentPage);

    this.scope.rotateLeft = () => {
      this.scope.imageEditorAction.rotateLeft()
    };
    this.scope.zoomOut = () => {
      this.scope.imageEditorAction.zoomOut();
    };
    this.scope.fit = () => {
      this.scope.imageEditorAction.fit();
    };
    this.scope.zoomIn = () => {
      this.scope.imageEditorAction.zoomIn();
    };
    this.scope.rotateRight = () => {
      this.scope.imageEditorAction.rotateRight();
    };

    /**
     * Modal for feedback
     */
    this.scope.openFeedbackModal = () => {
      $('.modal-edit-image').css('visibility', 'visible');
      var stop = true;

      _.forEach(this.scope.usersSelected, (value, key) => {
        if(value) {
          stop = false;
        }
      });

      if(stop) {
        return;
      }

      this.scope.hideModal();
      this.scope.showModal.feedback = true;
      //this.scope.feedback.toId = userId;
      $('body').css('overflow', 'hidden');
      $('#modal').modal('show');
    };

    /**
     * Edit avatar
     */
    this.scope.openEditImageModal = (user) => {
      this.scope.hideModal();
      this.scope.imageEdit = {
        url: this.scope.getAvatar(user.photoprofile.newUrl, ''),
        userId: user._id,
        key: user.photoprofile.origin
      };
      this.scope.showModal.image = true;
      $('.modal-edit-image').css('visibility', 'visible');
      $('body').css('overflow', 'hidden');
      $('#modal').modal('show');

      // Reopening a photo that is already in the <img> fires no load event, so
      // the cropper is told to start from a fit view rather than from wherever
      // the previous session left it. Deferred until the new url is applied.
      this.timeout(() => this.scope.imageEditorAction.reload());
    };

    this.scope.hideModal = () => {
      this.scope.showModal.feedback = false;
      this.scope.showModal.image = false;
      $('.modal-edit-image').css('visibility', '');
      $('body').css('overflow', 'auto');
    };

    // Only the close button carried ng-click="hideModal()". Bootstrap dismisses
    // the dialog by itself on Escape and on a backdrop click, so those paths
    // never restored the body and left the page underneath unscrollable.
    // Every close now funnels through the same handler.
    $('#modal').on('hidden.bs.modal.approveProfilePhotos', () => {
      this.timeout(() => this.scope.hideModal());
    });

    this.scope.$on('$destroy', () => {
      $('#modal').off('.approveProfilePhotos');
    });

    this.scope.updateImage = () => {
      let cropConfig = this.scope.imageEditorAction.getData();

      // No crop data means the editor never got a usable image (still loading,
      // or the avatar 404'd). Sending anyway used to throw and silently drop
      // the edit, leaving the admin to believe the photo had been saved.
      if (!cropConfig) {
        this.toastr.error('The photo is not ready to be edited yet, please reopen it');
        return;
      }

      let size = this.scope.imageEditorAction.getSize();
      let editedUserId = this.scope.imageEdit.userId;

      let params = {
        id: this.scope.imageEdit.userId,
        width: size.width,
        height: size.height,
        key: this.scope.imageEdit.key,
        cropConfig: cropConfig
      };

      this.PhotoService.updateAvatar(params)
        .then((response) => { let result = response.data;
          if (result.success) {
            // Only once the replacement rows are in scope, otherwise the scroll
            // would be measured against the list that is about to be discarded.
            // An edit removes nobody from the queue, whatever is checked.
            this.refreshPage(0).then(() => this.scrollToUser(editedUserId));
          } else {
            this.toastr.error(result.message || 'The photo could not be updated');
          }
        })
        .catch((response) => { let err = response.data;
          console.log(err);
          this.toastr.error('The photo could not be updated');
        });

      this.toastr.info('Please wait photo is being updated');
      $('.modal-edit-image').css('visibility', 'hidden');
      $('body').css('overflow', 'auto');
      $('#modal').modal('hide');
    };

    /**
     * Send feedback to user
     */
    this.scope.sendFeedback = (formData) => {

      if (!formReport.$valid) {
        this.formValidationForReport(formReport);
        return;
      }

      if (this.scope.feedback.reason === "" || this.scope.feedback.extraMessage === "") {
        this.toastr.error('Feedback hasn\'t sent. You must add message');
        return;
      }

      // let msg = "Your avatar cannot be approved, because it's contains "
      //   + this.scope.feedback.reason + ' \n' + this.scope.feedback.extraMessage;
      //
      // if (!this.scope.feedback.fromId) {
      //   this.scope.feedback.fromId = this.rootScope.currentUserProfile._id;
      // }

      this.scope.sendRejectData();
    }
  }

  formValidationForReport(form) {
    if (!form.$valid) {
      Object.keys(form).every((key, index, value) => {
        let findErr = true;
        switch (key) {
          case 'reason':
            if (form[key].$invalid) {
              this.toastr.error('Please, select the reason');
              break;
            }
          case 'onBehalfOf':
            if (form[key].$invalid) {
              this.toastr.error('Please, select the user');
              break;
            }
          default:
            findErr = false;
            break;
        }
        if (findErr) {
          $('form[name="' + form.$name + '"] *[name="' + key + '"]')[0].focus();
          return;
        }
        return key.length;
      });
      return;
    }
    return true;
  };

  /**
   * Refresh page content and pagination
   */
  refreshPage(itemsRemoved) {
    // Defaults to the checked users, who are the ones approving and rejecting
    // take out of the queue. Callers that remove nobody pass 0.
    if (itemsRemoved === undefined) {
      itemsRemoved = _.size(this.scope.usersSelected);
      _.forEach(this.scope.usersSelected, (val, key) => {
        if (val === false) {
          itemsRemoved--;
        }
      });
    }

    // Stay on the current page unless the removals put it past the end of the
    // shortened list.
    var lastPage = Math.max(1, Math.ceil((this.scope.pagination.total - itemsRemoved) / this.scope.pagination.limit));
    var page = Math.min(this.scope.pagination.currentPage, lastPage);

    return this.scope.getFilterUsers(page);
  }

  /**
   * Put the row that was just edited back where the admin left it.
   *
   * An edited user stays in the queue, so the row still exists after the
   * reload - but every avatar above it loads asynchronously and changes the
   * height of the rows in front of the target, so its offset is not
   * trustworthy yet. Scroll straight away so the page does not snap to the
   * top, then correct once the images have settled.
   */
  scrollToUser(userId) {
    const MARGIN = 80;
    const SETTLE_TIMEOUT = 4000;
    let lastSet = null;

    const settle = () => {
      const row = document.getElementById(`user-row-${userId}`);

      // The refresh may have landed on a page that no longer holds this user.
      if (!row) {
        return;
      }

      // Leave it alone once the admin starts scrolling on their own.
      if (lastSet !== null && Math.abs(window.pageYOffset - lastSet) > 4) {
        return;
      }

      window.scrollTo(0, Math.max(0, row.getBoundingClientRect().top + window.pageYOffset - MARGIN));
      lastSet = window.pageYOffset;
    };

    // Once ng-repeat has written the rows out.
    this.timeout(() => {
      settle();

      let pending = $('#example img').filter((i, img) => !img.complete);

      if (!pending.length) {
        return;
      }

      let outstanding = pending.length;
      pending.one('load error', () => {
        outstanding--;
        if (outstanding === 0) {
          settle();
        }
      });

      // A broken avatar may fire neither event, so correct once regardless.
      this.timeout(settle, SETTLE_TIMEOUT);
    });
  }
}
